import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_txn_ext_RowClass, bl_inv_txn_hdr_RowClass} from '../../../dbschema';
import {InventoryTransactionLineContainerModel} from '../inventory-transaction';

export class InventoryTransactionContainerModel extends BaseContainerModel {
  bl_inv_txn_hdr: bl_inv_txn_hdr_RowClass = new bl_inv_txn_hdr_RowClass();
  bl_inv_txn_exts: bl_inv_txn_ext_RowClass[] = [];
  inventoryTransactionLineContainers: InventoryTransactionLineContainerModel[] = [];
}




